module.exports = __webpack_public_path__ + "static/img/SC10.ecfd314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC10.jpg
// module id = i/+I
// module chunks = 0